<template>
  <v-card
    class="quantityPicker"
    :ripple="false"
    elevation="0"
  >
    <v-list-item
      class="pa-0 text-left"
      style="min-height: auto"
      three-line
    >
      <v-list-item-avatar
        tile
        class="ma-0 mr-6"
        size="96"
      >
        <v-img :src="fabric.rendered_image" />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title
          :title="fabric.name"
          class="text-body-1 primary--text mb-5"
        >
          {{ fabric.name }} curtain {{ accessory }}
        </v-list-item-title>
        <div class="d-flex align-baseline">
          <p class="text-body-1 mr-5 mb-0">
            Qty
          </p>
          <v-text-field
            :value="quantity"
            class="quantityPicker__input"
            outlined
            append-icon="mdi-plus"
            solo
            dense
            readonly
            @click:append="openDialog"
          />
        </div>
        <Dialog
          :dialog="dialog"
          :close-dialog="closeDialog"
          :locations="locations"
          @input="addLocation"
        />
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
import Dialog from '@/components/Dialogs/QuantityPickerDialog.vue'
import { TRACK_RAIL } from '@/constants.js'
import { mapGetters } from 'vuex'

export default {
  name: 'QuantityPicker',
  components: {
    Dialog
  },
  props: {
    quantity: {
      type: [String, Number],
      default: null
    },
    locations: {
      type: Array,
      default: () => ['']
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    ...mapGetters({
      totalPrice: 'order/getTotalOrderPrice',
      railRodType: 'order/getRailRodType',
      withRailRod: 'order/getWithRailRod'
    }),
    fabric() {
      // note that this component can be used for main fabrics only
      return this.$store.getters['order/getFabric'] || {}
    },
    accessory() {
      if (this.withRailRod) {
        return this.railRodType === TRACK_RAIL ? 'with Track' : 'with Rod'
      }
      return ''
    }
  },
  methods: {
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },
    addLocation(location) {
      this.$emit('addLocation', location)
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
.quantityPicker {
  &__input {
    max-width: 75px;
    .v-input__slot {
      border-radius: 4px !important;
      border-color: $border-input;
    }
    .v-text-field__details {
      min-height: 1px;
      margin-bottom: 0;
    }
  }
}
</style>
